import React, { useEffect, useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Fab } from '@mui/material';
import { buttonGlobalStyles } from '../theme/global';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Fab
      onClick={handleClick}
      size="small"
      sx={{
        ...buttonGlobalStyles,
        position: 'fixed',
        bottom: '2rem',
        right: '2rem',
        display: visible ? 'flex' : 'none',
        zIndex: 1000,
      }}
      aria-label="back to top"
    >
      <KeyboardArrowUpIcon />
    </Fab>
  );
};

export default BackToTop;